import { isAfter, isToday, subDays } from 'date-fns'
import { MouseEventHandler, useState } from "react"
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { useSelector } from "react-redux"
import DeleteConfirmPurchase from "../components/DeleteConfirmPurchase"
import Modal from "../components/Modal"
import { FormInput } from "../components/custom/components"
import { FormType, FormTypeList } from "../config"
import { LocalFormatDate } from "../config/functions"
import { AccountHolderType } from "../redux/actions/accountHolder"
import { AuthUserType } from "../redux/actions/authUserActions"
import { PurchaseType } from "../redux/actions/purchaseActions"
import { StoreState } from "../redux/store"


interface TableBody {
    sno: number
    invoiceDate: string
    invoiceNo: string
    purchaseEntryNo: string
    supplier: string
    finalAmount: string
    remainingBill: string
    showEditButton?: boolean
    onEdit: MouseEventHandler<HTMLButtonElement>
    onDelete: MouseEventHandler<HTMLButtonElement>
}

type HandleEdit = (value: PurchaseType) => void
type HandleDelete = (value: PurchaseType) => void

interface Props {
    setFormType: React.Dispatch<React.SetStateAction<FormType>>
    setId: React.Dispatch<React.SetStateAction<number | undefined>>
    onclose: () => void
    From: string
}

const Purchase = (props: Props) => {

    const purchaseList = useSelector<StoreState, PurchaseType[]>(state => state.purchase)
    const AuthUser = useSelector<StoreState, AuthUserType | null>(state => state.authUser);

    // const supplierList = useSelector<StoreState, SupplierType[]>(state => state.supplier)
    const AccountLists = useSelector<StoreState, AccountHolderType[]>(state => state.account)

    const [showDeleteForm, setShowDeleteForm] = useState<boolean>(false)
    // const [formType, setFormType] = useState<FormType>(FormTypeList.ADD)
    // const [id, setId] = useState<number>()

    const [editData, setEditData] = useState<PurchaseType>()

    const [searchDate, setSearchDate] = useState<Date | null>(null);
    const [searchSupplier, setSearchSupplier] = useState<string>('');
    const [searchInvoiceNo, setSearchInvoiceNo] = useState<string>('');

    const handleEdit: HandleEdit = (value) => {
        props.setFormType(FormTypeList.EDIT)
        props.setId(value.id)
        setEditData(value)
        console.log('edit');
        props.onclose()
    }

    const handleDelete: HandleDelete = (value) => {
        props.setFormType(FormTypeList.DELETE)
        setEditData(value)
        setShowDeleteForm(true)
    }

    const handleDeleteFormClose = () => {
        setShowDeleteForm(false)
    }

    // useEffect(() => {
    //     dispatch(fetchPurchaseAction())
    // }, [])

    const handleDateFilter = (date: Date | null) => {
        setSearchDate(date);
    };

    const handleSupplierFilter = (value: string) => {
        setSearchSupplier(value);
    };

    const handleInvoiceNoFilter = (value: string) => {
        setSearchInvoiceNo(value);
    };
    const isWithinLast7Days = (date: Date) => {
        const today = new Date();
        const sevenDaysAgo = subDays(today, 7);
        return isAfter(date, sevenDaysAgo) || isToday(date);
    };

    const filteredPurchaseList = purchaseList.filter((purchase) => {
        const purchaseDate = new Date(purchase.invoiceDate);
        const formattedDate = LocalFormatDate(purchase.invoiceDate?.toString());

        const isDateMatch = searchDate
            ? formattedDate === LocalFormatDate(searchDate.toISOString())
            : true;

        const normalizedSearchSupplier = searchSupplier.trim().toLowerCase();
        const normalizedSupplierName = (AccountLists.find(s => s?.accountNumber === purchase?.supplierId)?.accountName || '').toLowerCase();

        return (
            isDateMatch &&
            purchase.invoiceNumber?.toString().includes(searchInvoiceNo) &&
            normalizedSupplierName.includes(normalizedSearchSupplier)
        );
    });

    return <>
        {/* Filter Inputs */}
        <div className="row">
            <div className="col-lg-12">
                <div className="hstack gap-4 mb-3">
                    <div>
                        <label htmlFor="searchDate">Date :</label>
                        {/* <DatePicker
                            id="searchDate"
                            selected={searchDate}
                            onChange={(date) => handleDateFilter(date)}
                            // dateFormat="yyyy-MM-dd"
                            dateFormat="dd-MM-yyyy"
                        /> */}
                        <DatePicker
                            id="searchDate"
                            selected={searchDate}
                            onChange={(date) => handleDateFilter(date)}
                            dateFormat="dd-MM-yyyy"
                            isClearable
                        />
                    </div>
                    <FormInput
                        name='searchInvoiceNo'
                        label='Invoice No :'
                        value={searchInvoiceNo}
                        onChange={(e) => handleInvoiceNoFilter(e.target.value)}
                    />
                    <FormInput
                        name='searchSupplier'
                        label='Supplier :'
                        value={searchSupplier}
                        onChange={(e) => handleSupplierFilter(e.target.value)}
                    />
                </div>
            </div>
        </div>

        <Modal
            headerText={'Delete Purchase'}
            visible={showDeleteForm}
            onClose={handleDeleteFormClose}
            centered
            size='sm'
        >
            <DeleteConfirmPurchase
                editData={editData}
                onClose={handleDeleteFormClose}
            />
        </Modal>
        <div className="row">
            <div className="col-lg-12">
                <div className="card shadow-lg">
                    {/* <div className="card-body"> */}
                    <div className='table-wrapper' style={{ zIndex: "0" }}>
                        <table className="table">
                            <thead>
                                <tr>
                                    <th className='text-truncate align-middle'>S.No</th>
                                    <th className='text-truncate align-middle'>Purchase Entry No</th>
                                    <th className='text-truncate align-middle'>Invoice Date</th>
                                    <th className='text-truncate align-middle'>Invoice No</th>
                                    <th className='text-truncate align-middle'>Supplier</th>
                                    <th className='text-truncate align-middle'>Grand Total</th>
                                    <th className='text-truncate align-middle'>Status</th>
                                    <th className='text-truncate align-middle'>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredPurchaseList?.filter(f => props.From === 'OpeningStock' ? f.remarks === 'OpeningStock' : f).map((tr, i) => {
                                    let sobj = AccountLists?.find(s => s?.accountNumber === tr?.supplierId)
                                    let sname = sobj?.accountName ? sobj?.accountName : ''
                                    return <UserBody
                                        sno={i + 1}
                                        invoiceNo={tr.invoiceNumber?.toString()}
                                        invoiceDate={tr.invoiceDate?.toString()}
                                        purchaseEntryNo={tr.purchaseEntryNumber?.toString()}
                                        finalAmount={tr.grandTotal ? tr.grandTotal?.toString() : '0'}
                                        remainingBill={tr.remainingRecordExist ? 'NOT COMPLETED' : 'COMPLETED'}
                                        supplier={sname}
                                        showEditButton={!!tr?.remainingRecordExist}
                                        onEdit={() => handleEdit(tr)}
                                        onDelete={() => handleDelete(tr)}
                                        key={i}

                                    />
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
                {/* </div> */}
            </div>
        </div>
    </>
}

const UserBody = ({ sno, invoiceDate, finalAmount, invoiceNo, purchaseEntryNo, supplier, remainingBill, showEditButton, onEdit, onDelete }: TableBody) => {
    const AuthUser = useSelector<StoreState, AuthUserType | null>(state => state.authUser);

    const isWithinLast7Days = (date: string) => {
        const today = new Date();
        const sevenDaysAgo = subDays(today, 7);
        const parsedDate = new Date(date);
        return isAfter(parsedDate, sevenDaysAgo) || isToday(parsedDate);
    };
    return <tr key={sno}>
        <td className='align-middle'>{sno}</td>
        <td className='text-capitalize fw-bold align-middle'>{purchaseEntryNo}</td>
        <td className='text-capitalize fw-bold align-middle'>{LocalFormatDate(invoiceDate)}</td>
        <td className='text-capitalize fw-bold align-middle'>{invoiceNo}</td>
        <td className='text-capitalize fw-bold align-middle'>{supplier}</td>
        <td className='text-capitalize fw-bold align-middle'>{finalAmount}</td>
        <td><span className={`align-middle fs-5 badge ${remainingBill === 'NOT COMPLETED' ? 'bg-danger blink' : 'bg-success'}`}>
            {remainingBill}
        </span></td>
        {/* {(AuthUser?.name === 'Super'|| isWithinLast7Days(invoiceDate)) && <td className="align-middle"> */}
        <td>
            <div className=' hstack gap-1  justify-content-center'>
                <button className='btn btn-sm fw-bold btn-info ' onClick={onEdit}><i className="fe-edit noti-icon"></i></button>
                {(AuthUser?.role === 'SUPER' && <button className='btn btn-sm fw-bold btn-danger ' onClick={onDelete}><i className="fe-trash-2 noti-icon"></i></button>)}
            </div>
        </td>
    </tr>
}
export default Purchase